import { NgModule } from '@angular/core';
import { NumberOnlyDirective } from './number-only.directive';
import { NumberOnlyDecimalDirective } from './number-only-decimal.directive';
import { InsertionDirective } from './insertion.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { RoblexMaskDirective } from './mask.directive';
import { UpperCaseDirective } from './upper-case.directive';
import { SwitchCasesDirective } from './switch-cases.directive';

const directives = [
    NumberOnlyDirective,
    NumberOnlyDecimalDirective,
    InsertionDirective,
    ClickOutsideDirective,
    RoblexMaskDirective,
    UpperCaseDirective,
    SwitchCasesDirective
];

@NgModule({
    declarations: [...directives],
    exports: [...directives],
    providers: []
})
export class RoblexDirectivesModule {
    //
}
